import {gql} from '@apollo/client'

export const GET_MY_POLICY_FILTERS = gql`
  query myPolicyFilters($scope: String) {
    myPolicyFilters(scope: $scope) {
      id
      name
      scope
      filters
      created
      updated
    }
  }
`
